import { render, staticRenderFns } from "./Startseite.vue?vue&type=template&id=46e6b82c"
import script from "./Startseite.vue?vue&type=script&lang=js"
export * from "./Startseite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports